import { useEffect } from "react";
import { useAuthStore } from "../contexts/AuthContext";
// import { use } from "../contexts/RoleContext";
import { useCategoryDispatch } from "../contexts/CategoryContext";

export default function useGetCategories() {
    const categoryDispatch = useCategoryDispatch();
  const { selectedAccount } = useAuthStore();

  useEffect(() => {
    categoryDispatch({type: "setIsLoadingCategories", payload: true})

    let url = "/api/categories";

    fetch(url)
      .then((r) => r.json())
      .then((data) => {
        categoryDispatch({ type: "setCategories", payload: data });
        categoryDispatch({ type: "setIsLoadingCategories", payload: false });
      });
  }, [categoryDispatch, selectedAccount]);
}
